import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { SharedService } from 'src/app/shared/shared.service';
import {
  LaboratorioLezioneTutoraggioDTO,
  ListLaboratorioLezioneTutoraggioDTO,
  SelectDTO,
} from './../../../../model/newModel';
import { ALaboratorioLezioneTutoraggioService } from './../a-laboratorio-lezione-tutoraggio.service';

@Component({
  selector: 'app-appelli-laboratori-lezione-tutoraggio',
  templateUrl: './appelli-laboratori-lezione-tutoraggio.component.html',
  styleUrls: ['./appelli-laboratori-lezione-tutoraggio.component.css'],
})
export class AppelliLaboratorioLezioneTutoraggioComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  options = {
    format: 'DD/MM/YYYY, HH:mm',
  };
  listLaboratorioLezioneTutoraggio: ListLaboratorioLezioneTutoraggioDTO;
  tipologieAbilitatoDisabilitato: SelectDTO[];
  dataSelected: Date;
  tempListLaboratorioLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO[];

  showAppelliDaFare: boolean;

  ngOnInit(): void {
    this.tipologieAbilitatoDisabilitato = this.sharedService.allSelectTipologieAbilitatoDisabilitato();
    super.ngOnInit();
    this.getListLaboratorioLezioneTutoraggio();
  }

  filtroFE(dataSelected: Date) {
    this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio = this.tempListLaboratorioLezioneTutoraggio.filter(
      (laboratorioLezioneTutoraggio: LaboratorioLezioneTutoraggioDTO) => {
        let filterData = true;
        if (dataSelected) {
          const dataInizio = new Date(laboratorioLezioneTutoraggio.dataInizio);
          filterData =
            dataInizio.getDay() === dataSelected.getDay() &&
            dataInizio.getFullYear() === dataSelected.getFullYear();
        }
        return filterData;
      }
    );
  }

  goToLaboratorioDetail(idLaboratorioLezioneTutoraggio: number) {
    this.router.navigate(['/a-laboratorio-lezione-tutoraggio/dettaglio'], {
      queryParams: {
        idLaboratorioLezioneTutoraggio: idLaboratorioLezioneTutoraggio,
      },
    });
  }

  getListLaboratorioLezioneTutoraggio() {
    this.spinner.show();
    this.aLaboratorioLezioneTutoraggioService
      .search('' + this.instructor.id, '', '', null, false)
      .subscribe(
        (result) => {
          this.listLaboratorioLezioneTutoraggio = result;
          if (
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio
              .length > 0
          ) {
            this.showAppelliDaFare = true;
          } else {
            this.showAppelliDaFare = false;
          }
          if (
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio &&
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio
              .length > 0
          ) {
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio = this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio.filter(
              (item: LaboratorioLezioneTutoraggioDTO) => {
                return !item.appelloEffettuato && item.active;
              }
            );
          }
          this.tempListLaboratorioLezioneTutoraggio = Object.assign(
            [],
            this.listLaboratorioLezioneTutoraggio.laboratoriLezioneTutoraggio
          );
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore search');
        }
      );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  constructor(
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    public router: Router,
    private aLaboratorioLezioneTutoraggioService: ALaboratorioLezioneTutoraggioService
  ) {
    super();
  }
}
